import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './PromoteListingModal.scss';

const MAX_FILE_SIZE_BYTES = 1024 * 1024 * global.maxFileUploadSize;
const MAX_FILE_SIZE_STRING = global.maxFileUploadSize + ' MB';
const URL_REGEXP = /^https?:\/\/[\w-.]+\/.*$/i;

export default class PromoteListingModal extends Component {
    static get propTypes() {
        return {
            requestId: PropTypes.number,
            responseId: PropTypes.number,
            isBuyer: PropTypes.bool,
            onUploadFinished: PropTypes.func
        };
    }

    state = {
        isLoading: false,
        error: null,
        url: null,
        file: null,
        uploaded: false
    };

    fileInputRef = React.createRef();

    handleUrlChange(event) {
        const url = (event.target.value || '').trim();
        this.setState({
            url,
            error: (url && !URL_REGEXP.test(url)) ? 'Please enter a valid URL' : null
        });
    }

    handleChooseButtonClick() {
        this.fileInputRef.current && this.fileInputRef.current.click();
    }

    handleFileChange(event) {
        const file = event.target.files[0];
        if (!file) {
            this.setState({file: null, error: null});
            return;
        }

        if (file.size > MAX_FILE_SIZE_BYTES) {
            this.fileInputRef.current.value = '';
            this.setState({
                file: null,
                error: `This file is too large (over ${MAX_FILE_SIZE_STRING})`
            });
            return;
        }

        console.log('Selected file:', file);
        this.setState({file, url: null, error: null});
    }

    handleRemoveFileButtonClick() {
        this.fileInputRef.current.value = '';
        this.setState({file: null});
    }

    handleFormSubmit(event) {
        event.preventDefault();

        const form = event.target;
        const formData = new FormData(form);

        this.setState({isLoading: true});
        $.ajax({
            url: form.action,
            method: form.method,
            processData: false,
            contentType: false,
            data: formData
        }).then(data => {
            if (data.requestId) {
                this.setState({uploaded: true});
                if (this.props.onUploadFinished) {
                    this.props.onUploadFinished();
                }
            } else {
                checkAjax(data);
            }
        }).always(() => {
            this.setState({isLoading: false});
        });
    }

    render() {
        const {isLoading, uploaded, error, url, file} = this.state;
        const {requestId, responseId, isBuyer} = this.props;

        return (
            <div className="modal nu-modal fade mobile-full-screen promote-listing-modal">
                <div className="modal-dialog">
                    {uploaded ?
                        <div className="modal-content success">
                            <div className="modal-header pt-0x pl-6x-sm pr-6x-sm">
                                <div className="modal-title">
                                    <div className="mb-3x text-center main-icon">
                                        <img src={global.imageBaseUrl + 'proposal/selling.svg'}/>
                                    </div>
                                    Thank you!
                                </div>
                            </div>
                            <div className="modal-body pl-6x-sm pr-6x-sm">
                                <div className="message mb-3x">
                                    We will update the status of your request once we have verified the information.
                                </div>
                                <div className="text-center">
                                    <button
                                        type="button"
                                        className="btn btn-gray-outline close-button"
                                        data-dismiss="modal">
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                        :
                        <form
                            action="uploadAgreement-json"
                            method="POST"
                            encType="multipart/form-data"
                            className="modal-content"
                            onSubmit={this.handleFormSubmit.bind(this)}>
                            <input type="hidden" name="requestId" value={requestId}/>
                            <input type="hidden" name="quoteId" value={responseId}/>
                            <input type="hidden" name="buy" value={isBuyer}/>
                            <input type="hidden" name="clientUploadAgreement" value="true"/>
                            <div className="modal-header pl-6x-sm pr-6x-sm">
                                <div className="modal-title mt-3x">
                                    <div className="mb-3x text-center main-icon">
                                        <img src={global.imageBaseUrl + 'proposal/selling.svg'}/>
                                    </div>
                                    Promote Your Listing for Free
                                </div>
                            </div>
                            <div className="modal-body pl-6x-sm pr-6x-sm">
                                <div className="message mb-3x mb-8x-sm">
                                    We may promote your listing on our social media channel to get more buyers to your
                                    open house. We need your listing agreement to verify your listing.
                                </div>
                                <div className="big-message mb-2x mb-3x-sm text-center">Listing Agreement</div>
                                {file ?
                                    <div className="mb-2x mb-3x-sm file-preview">
                                        <img src={global.imageBaseUrl + 'proposal/document.svg'}/>
                                        {file.name || 'File.pdf'}
                                        <a className="touch-opacity" onClick={this.handleRemoveFileButtonClick.bind(this)}>
                                            <img className="file-icon" src={global.imageBaseUrl + 'proposal/delete.svg'}/>
                                        </a>
                                    </div>
                                    : [
                                        <div key="url" className="mb-2x mb-3x-sm">
                                            <input
                                                type="url"
                                                name="listingAgreementUrl"
                                                value={this.state.url}
                                                placeholder="Paste URL of a PDF document"
                                                className="form-control url-input"
                                                onInput={this.handleUrlChange.bind(this)}/>
                                        </div>,
                                        <div key="file" className="big-message">
                                            or
                                            <button
                                                type="button"
                                                className="ml-1x btn btn-gray-outline file-button"
                                                onClick={this.handleChooseButtonClick.bind(this)}>
                                                Choose File
                                            </button>
                                            {error &&
                                                <div className="error mt-2x">{error}</div>
                                            }
                                        </div>
                                    ]
                                }
                                <input
                                    ref={this.fileInputRef}
                                    type="file"
                                    name="agreement"
                                    accept=".pdf"
                                    style="display: none"
                                    onChange={this.handleFileChange.bind(this)}/>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-transparent"
                                    data-dismiss="modal"
                                    onClick={() => trackEvent('Quote', 'uploadAgreementCancel')}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-default"
                                    disabled={isLoading || error || (!url && !file)}
                                    onClick={() => trackEvent('Quote', 'uploadAgreement')}>
                                    Promote Listing
                                </button>
                            </div>
                            {isLoading &&
                                <div className="loadingSpinner" style="display: block; margin: 0">
                                    <img src={global.imageBaseUrl + 'spinner.gif'}/>
                                </div>
                            }
                        </form>
                    }
                </div>
            </div>
        );
    }
}
